import { render, staticRenderFns } from "./payFail.vue?vue&type=template&id=7c41068e&scoped=true"
import script from "./payFail.vue?vue&type=script&lang=ts"
export * from "./payFail.vue?vue&type=script&lang=ts"
import style0 from "./payFail.vue?vue&type=style&index=0&id=7c41068e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c41068e",
  null
  
)

export default component.exports